export default __webpack_public_path__ + "static/media/philosophies_of_resistance.bf500eee.png";